import { render, staticRenderFns } from "./Backlog.vue?vue&type=template&id=6c5d56b6&scoped=true&"
import script from "./Backlog.vue?vue&type=script&lang=js&"
export * from "./Backlog.vue?vue&type=script&lang=js&"
import style0 from "./Backlog.vue?vue&type=style&index=0&id=6c5d56b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5d56b6",
  null
  
)

export default component.exports